export default {
      id: "key-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#key-usage",
      toString: function () {
        return this.url;
      }
    }